export { default as Animations } from './Animations.js';
export { P as BluBlocksProvider, c as colors } from './Provider-3f8422ca.js';
export { B as Button } from './Button-f1221d49.js';
import styled, { keyframes } from 'styled-components';
export { default as Content } from './Content.js';
export { default as FAIcon } from './FAIcon.js';
import React from 'react';
export { H as Hamburger } from './Hamburger-ee802cd2.js';
export { default as Icon } from './Icon.js';
export { default as ResetButton } from './ResetButton.js';
import 'polished';
import '@bluframe/grapple';
import 'react-markdown';
import '@react-icons/all-files/io5/IoAccessibilityOutline';
import '@react-icons/all-files/io5/IoBulbOutline';
import '@react-icons/all-files/io5/IoChatbubbleOutline';
import '@react-icons/all-files/io5/IoCloudOutline';
import '@react-icons/all-files/io5/IoHeartOutline';
import '@react-icons/all-files/io5/IoLaptopOutline';
import '@react-icons/all-files/io5/IoMapOutline';
import '@react-icons/all-files/io5/IoPaperPlaneOutline';
import '@react-icons/all-files/io5/IoSpeedometerOutline';

const Column = styled.div.withConfig({
  displayName: "Column",
  componentId: "sc-3fl3fy-0"
})(["min-height:1px;position:relative;"]);

const mediaQueries = {
  desktop: "@media only screen and (min-width: 1024px)",
  tablet: "@media only screen and (min-width: 768px)"
};

const Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1wq410m-0"
})(["margin-right:auto;margin-left:auto;padding:0;padding-right:0;padding-left:0;&:after{clear:both;content:\" \";display:block;}", "{padding-right:15px;padding-left:15px;}@media (min-width:768px){width:750px;}@media (min-width:992px){width:970px;}@media (min-width:1200px){width:1170px;}@media (max-width:767px){width:auto;}@media (max-width:979px){width:auto;}@media only screen and (max-width:1110px) and (min-width:980px){width:96%;}@media (max-width:992px){width:100%;}"], mediaQueries.desktop);

const fadeInLeft = keyframes(["0%{opacity:0;transform:translateX(-20px);}100%{opacity:1;transform:translateX(0);}"]);

const fadeInRight = keyframes(["0%{opacity:0;transform:translateX(20px);}100%{opacity:1;transform:translateX(0);}"]);

const fadeInUp = keyframes(["0%{opacity:0;transform:translateY(20px);}100%{opacity:1;transform:translateY(0);}"]);

/* eslint-disable no-ternary, no-nested-ternary */
const Wrapper$1 = styled.div.withConfig({
  displayName: "styled__Wrapper",
  componentId: "sc-1cykrzd-0"
})(["animation:", ";animation-duration:1s;animation-fill-mode:both;animation-play-state:", ";"], ({
  fadeIn
}) => fadeIn === "Left" ? fadeInLeft : fadeIn === "Right" ? fadeInRight : fadeInUp, ({
  isAnimated
}) => isAnimated ? "running" : "paused");

const FadeIn = ({
  children,
  fadeIn,
  isAnimated
}) => /*#__PURE__*/React.createElement(Wrapper$1, {
  fadeIn: fadeIn,
  isAnimated: isAnimated
}, children);

const flipInX = keyframes(["0%{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0;}40%{-webkit-transform:perspective(400px) rotateX(-10deg);transform:perspective(400px) rotateX(-10deg);}70%{-webkit-transform:perspective(400px) rotateX(10deg);transform:perspective(400px) rotateX(10deg);}100%{-webkit-transform:perspective(400px) rotateX(0deg);transform:perspective(400px) rotateX(0deg);opacity:1;}"]);

const flipInY = keyframes(["0%{-webkit-transform:perspective(400px) rotateX(90deg);-ms-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0;}40%{-webkit-transform:perspective(400px) rotateX(-10deg);-ms-transform:perspective(400px) rotateX(-10deg);transform:perspective(400px) rotateX(-10deg);}70%{-webkit-transform:perspective(400px) rotateX(10deg);-ms-transform:perspective(400px) rotateX(10deg);transform:perspective(400px) rotateX(10deg);}100%{-webkit-transform:perspective(400px) rotateX(0deg);-ms-transform:perspective(400px) rotateX(0deg);transform:perspective(400px) rotateX(0deg);opacity:1;}"]);

/* eslint-disable no-ternary */
const Wrapper = styled.div.withConfig({
  displayName: "styled__Wrapper",
  componentId: "sc-1yhc6yo-0"
})(["animation:", ";animation-duration:1s;animation-fill-mode:both;animation-play-state:", ";"], ({
  flip
}) => flip === "X" ? flipInX : flipInY, ({
  isAnimated
}) => isAnimated ? "running" : "paused");

const Flip = ({
  children,
  flip,
  isAnimated
}) => /*#__PURE__*/React.createElement(Wrapper, {
  flip: flip,
  isAnimated: isAnimated
}, children);

const Row = styled.div.withConfig({
  displayName: "Row",
  componentId: "sc-twiixp-0"
})(["", ";"], ({
  center
}) => center && "text-align: center");

const Section = styled.section.withConfig({
  displayName: "Section",
  componentId: "sc-wck3wb-0"
})(["padding:20px 10px;", "{padding:60px 20px;}"], mediaQueries.tablet);

export { Column, Container, FadeIn, Flip, Row, Section, mediaQueries };
